var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicePackageMigration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 7.51501L5.10002 3.35501C5.37933 2.98032 5.74232 2.67607 6.16004 2.46651C6.57777 2.25696 7.03867 2.14789 7.50602 2.14801H20.494C20.9612 2.14805 21.4219 2.25719 21.8394 2.46674C22.257 2.67629 22.6198 2.98046 22.899 3.35501L25.8448 7.25315V7.51501M2.00002 7.51501V23.316C1.99883 23.6674 2.06688 24.0155 2.20029 24.3406C2.33369 24.6657 2.52982 24.9613 2.77749 25.2105C3.02516 25.4598 3.3195 25.6578 3.64371 25.7932C3.96792 25.9287 4.31564 25.999 4.66702 26H18.4163M2.00002 7.51501H25.8448M25.8448 7.51501V18.4338",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.25C24.8995 27.25 27.25 24.8995 27.25 22C27.25 19.1005 24.8995 16.75 22 16.75C19.1005 16.75 16.75 19.1005 16.75 22C16.75 24.8995 19.1005 27.25 22 27.25Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9838_5387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 6,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19H25V25H19V19Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9838_5387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 20V21.5H20.75M24.75 24V22.5H23.25",
    stroke: "#76BC21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.122 21.25C23.9952 20.8918 23.7797 20.5716 23.4956 20.3191C23.2116 20.0667 22.8683 19.8903 22.4976 19.8065C22.127 19.7226 21.7412 19.734 21.3761 19.8395C21.0111 19.945 20.6787 20.1413 20.41 20.41L19.25 21.5M24.75 22.5L23.59 23.59C23.3213 23.8587 22.9889 24.055 22.6239 24.1605C22.2588 24.2661 21.873 24.2774 21.5024 24.1936C21.1317 24.1097 20.7884 23.9333 20.5044 23.6809C20.2203 23.4285 20.0048 23.1082 19.878 22.75",
    stroke: "#76BC21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicePackageMigration);
export default __webpack_public_path__ + "static/media/servicePackageMigration.6302792badb71b927af144ae2c59b8c4.svg";
export { ForwardRef as ReactComponent };